import { Button,  Form, Upload, Select, Drawer,message, Collapse, Empty } from "antd";
import React from "react";
import api from "utils/api";
import Loader from "Components/Loader";
import utils from "utils";
import { CONSTANTS } from 'utils/constant';
import "./CaseNotes.scss"
import { UploadOutlined } from '@ant-design/icons';
const { Panel } = Collapse;
 class MultiDocUploadTab extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            showDropDown:false,
            showInsert: false,
            file_type: "",
            uploadDocument:[],
            invalidDocuments:[],
            app_id: this.props.appointment_id,
            showDrawer:false,
            viewUploadedDocs:[],
            uploadTypes:[],
            miniHeight:"10vh",
        }
       
        this.form = React.createRef()
    }

    getUploadedDocument()
    {
        api.get_uploaded_files(this.state.app_id).then(response =>{
            let { data, status} = response.data || {};
            if(status == 200)
            {
              this.setState({viewUploadedDocs : data})
            }
        })
    }

    componentDidMount()
    {
        api.get_upload_types().then(response =>{
            let { data, status} = response.data || {};
            if(status == 200)
            {
                let duplicateType = data?.results.map((element) => {
                  return {                    
                    field_id: element["field_id"],                    
                    sort_id: element["sort_id"],                    
                    value:element["field_type"],
                    label:element["field_name"]                    
                   };                    
                  });              
              this.setState({uploadTypes : duplicateType })
            }
        })
        this.getUploadedDocument();
    }

    addFilesClicked(){
        this.setState({showDropDown:true})
    }

    showUploadedFiles()
    {
       if(this.state.viewUploadedDocs)
       {
        this.setState({showDrawer:true,miniHeight:"55vh"})
       }
       else
       {
        this.setState({showDrawer:true,miniHeight:"20vh"})
       }
    }

    onSubmit() {
        this.setState({isLoading:true})
        if(this.state.invalidDocuments.length>0)
        {
            message.error("Remove the invalid documents to upload.", ErrorDuration);
            this.setState({isLoading:false})
            return;
        }
        
        let formdata = new FormData();
        let count = this.state.uploadDocument.length;
        if(!count || count < 1)
        {
            message.error("No files selected.", ErrorDuration)
            this.setState({isLoading:false,showInsert:false})
            return;
        }
        this.state.uploadDocument.map((file,i)=>{
            formdata.append("file_path_"+i, file);
        })
        formdata.append("count", count);
        formdata.append("type", this.state.file_type);
        formdata.append("appointment_id", this.state.app_id);
        api.upload_multiple_documents(formdata).then(response => {
            let { data, status, } = response.data || {};
            if (status == 200) {
                message.success(response.data?.message || "Files uploaded successfully" , ErrorDuration)
                this.setState({uploadDocument:[],file_type:"",showDropDown:false,showInsert:false,isLoading:false})
                this.props.formAction(false)
                this.getUploadedDocument();
            }
            else {
                message.error(response?.data?.message || "Failed to upload files." , ErrorDuration)
                this.setState({isLoading:false})
            }
            
        })
        this.setState({uploadDocument:[],file_type:"",showDropDown:false,showInsert:false})
    }
    
    previewDoc(url)
    {
        utils.Modal(true, {
            width: "1023px",
            content:
            <div style={{height:"75vh"}} className="finish-Consult-Modal">
            <div className="finish-header">Preview Document</div>
            <div  style={{height:"65vh",overflow:"auto",display:"flex",justifyContent:"center"}} className="finish-wrapper">
                {url.includes("pdf")?
               <object height="550" width="800" data={url}></object>:
               <object height="550" data={url}></object>} 
            </div>
        </div>
          })
    }


    render() {
        const uploadProps = {
             showUploadList: { showPreviewIcon: false },
            accept: ".png, .jpg, .jpeg, .pdf",
            progress: {
                type: "line"
            },
            onRemove: file => {
                let count = this.state.invalidDocuments.filter(e => {
                    if( e.uid == file.uid)
                    { return(e); }})
                        if(count.length>0)
                    {
                            this.setState(state => {
                                let index = "";
                                state.invalidDocuments.filter((e,i) => {
                                if( e.uid == file.uid)
                                    { index = i; }})
                                    const newincorrectDocument = state.invalidDocuments.slice();
                                    newincorrectDocument.splice(index, 1);
                                    return {
                                        invalidDocuments: newincorrectDocument,
                                    };
                                });
                        }
                    else{
                            this.setState(state => {
                                const index = state.uploadDocument.indexOf(file);
                                const newuploadDocument = state.uploadDocument.slice();
                                newuploadDocument.splice(index, 1);
                                return {
                                    uploadDocument: newuploadDocument,
                                };
                            });
                        } 
            },
            beforeUpload: (data, fileList) => {
                let docArray = [];
                let incorrectFiles=[];
                 let totalFile=this.state.uploadDocument.length+this.state.invalidDocuments.length;
                 let incomingFile=this.state.uploadDocument.length+fileList.length                
                    fileList.map((file,index) => {
                        let isError = false;
                        file.status = "uploading";
                        const isValidType = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'application/pdf';
                        let isLt2M = false;
                        if (file.size > 1024) isLt2M = file.size / 1024 / 1024 > 25;
                        //else isLt2M = file.size > 25;
                        if (!isValidType) {
                            file.status = "error";
                            isError = true;
                            message.error("You can upload only JPG/PNG/PDF format.", ErrorDuration);
                            incorrectFiles.push(file);
                            return; 
                        }
                        else if(this.state.uploadDocument.length >= 3 || totalFile >=3 || incomingFile > 3 || totalFile+fileList.length > 3 )
                        {
                            file.status = "error";
                            isError = true;
                            let i = 3 - (this.state.uploadDocument.length + this.state.invalidDocuments.length )
                            if(index+1<=i && (incorrectFiles.length+this.state.invalidDocuments.length<3))
                            {incorrectFiles.push(file)}
                            message.error("You can upload maximum 3 document(s).", ErrorDuration);
                            return ;
                        }
                        else if (isLt2M) {
                            file.status = "error";
                            isError = true;
                            message.error(CONSTANTS.FILE_SIZE_25, ErrorDuration);
                            incorrectFiles.push(file);
                            return; 
                        }
                        else {
                            file.status = "success";
                        }
                        docArray.push(file);
                        this.props.formAction(true)
                    }) 
                    if(incorrectFiles.length>0)
                    {
                        this.setState({invalidDocuments:[...incorrectFiles], uploadDocument: [...this.state.uploadDocument,...docArray]});
                        return isError && [fileList];
                    }
                    else if(this.state.uploadDocument.length>0)
                    {
                        this.setState({
                            uploadDocument: [...this.state.uploadDocument,...docArray],invalidDocuments:[...incorrectFiles]
                        });
                        return isError && [fileList];
                    }
                    else{
                        this.setState({
                            uploadDocument: [...docArray],
                        });
                        return isError && [fileList];
                    }            
            },
        };
        const viewProps = {
            showUploadList: { showPreviewIcon: true },
            onPreview:file =>{
                this.previewDoc(file.url+"#toolbar=0&scrollbar=0")
            },
            onRemove: file => {
                utils.Modal(true, {
                    width: "600px",
                    // closable: false,
                    content:
                    <div className="finish-Consult-Modal">
                    <div className="finish-header">Delete File</div>
                    <div className="finish-wrapper">
                        <div style={{marginBottom:"15px"}} className="finish-title">Are you sure you want to delete the uploaded document?</div>
                        <div className="finish-btns">
                            <button className="action-yes"
                            onClick={()=>
                            {
                                    this.state.viewUploadedDocs.map((types)=>{ 
                                       if(types?.file_path?.length>0)
                                      {  for(let i of types.file_path){
                                            for(const [a] of Object.entries(i)){
                                                if(file.key == a)
                                            {
                                                let formdata = new FormData();
                                                formdata.append("file_path", a);
                                                formdata.append("appointment_id", this.state.app_id)
                                                formdata.append("type", types.type);
                                                api.delete_uploaded_doc(formdata).then(response =>{
                                                    let { data, status} = response.data || {};
                                                    if(status == 200)
                                                    {
                                                      message.success(data ||"Deleted file successfully." , ErrorDuration);
                                                    }
                                                    else{
                                                        message.error(data ||"Failed to delete file." , ErrorDuration);
                                                    }
                                                    utils.Modal(false);
                                                    this.getUploadedDocument();
                                                    return;
                                                })
                                            }
                                            }
                                        }
                                        }
                                    })
                            }}>Yes</button>
                            <button className="action-no" onClick={() => { utils.Modal(false)} }>No</button>
                        </div>
                    </div>
                </div>
                  })
            }
        };
        return (
         <> {this.state.isLoading? <Loader /> : 
         <> <Form style={{minHeight:this.state.miniHeight}} ref={this.form} onFinish={() => this.onSubmit()}>
         <Form.Item>
        <div style={{display:"flex", justifyContent:"space-between"}}>
        <Button className='addfiles' onClick={()=>{
                 this.addFilesClicked()
             }}>Add Files</Button>
               <Button className='addfiles' onClick={()=>{
                 this.showUploadedFiles()
             }}>View uploaded files</Button>
        </div>
             
             
         </Form.Item>
         {this.state.showDropDown?
          <Form.Item >
             <div style={{display:"grid"}}>
             <Select onChange={(e) => {
                this.props.formAction(true)
              this.setState({ showInsert: true, file_type: e })
          }}
              style={{
                  width: "50%", marginTop:"10px"
              }}
              placeholder="Select Report"
              optionFilterProp="children"

              options={this.state.uploadTypes }
          />
          <label style={{marginTop:"5px"}}>You can upload only JPG/PNG/PDF format below 25MB.</label>
          <label style={{marginTop:"5px"}}>You can select upto 3 documents to upload.</label>
      
             </div>
          </Form.Item>
       : null}
        
         {this.state.showInsert ? <div style={{ padding: "10px 0px" }}>
             <Form.Item>
                 <Upload multiple maxCount={3} {...uploadProps} listType="picture-card"
                 >
                    {((this.state.uploadDocument.length>=3) ||( this.state.invalidDocuments.length >0) || (this.state.uploadDocument.length+this.state.invalidDocuments.length>=3))?null:
                    <Button icon={<UploadOutlined />}></Button>}
                 </Upload>
             </Form.Item>
             <Form.Item>
             {this.state.invalidDocuments.length == 0 ?<Button className='addfiles' onClick={() => this.form.current.submit()}> Upload</Button>:
             null}
         
     </Form.Item></div> : null}
       
     </Form>
     {this.state.showDrawer?
     <>
      <Drawer  destroyOnClose={true}
             title={
                 <div className='protective-factor-title'>
                     Documents Upload
                 </div>
             }
             getContainer={false}
             width={"80vw"}
             placement="right"
             closable={false}
             open={this.state.showDrawer}
             extra={
                 <Button className='close-button' onClick={() => { this.setState({showDrawer:false,miniHeight:"10vh"})}}>{CONSTANTS.CLOSE}</Button>
             }
         >
                        <>  
                        {this.state.viewUploadedDocs.length>0? <>
                                 {this.state.viewUploadedDocs.map((docTypes,i)=>{
                                let imageFile = []
                                 if(docTypes?.file_path)
                                 { for(let i of docTypes?.file_path){
                                     for(const [a,b] of Object.entries(i)){
                                         imageFile.push({url:b, key:a})
                                     }
                                 }

                                 return(
                                     <>
                                      <Collapse defaultActiveKey={i} className='prescription-list-container' bordered={true} expandIconPosition="start" ghost={true}> 
                                      <Panel bordered header={docTypes.value} key={i}>
                                      <Upload fileList={imageFile}  {...viewProps} listType="picture-card">
                                      </Upload>
                                      </Panel>
                                      </Collapse>
                                     </>
                                 )}
                             })}</>:
                                <Empty
                                 description={"No Data"}
                                 image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                         </>   
         </Drawer>
     </> :
     null}
         </>} 
        
          </>  
        )
    }
}


export default MultiDocUploadTab; 